import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { SpaceProps } from '../../../../theme/styledProps';
import { DraftAccountDTO, yesNoOpts } from '../../AccountOpening.meta';
import { BrokerFirmName } from '../BrokerFirmName/BrokerFirmName';
import { Letter407Upload } from '../Letter407Upload/Letter407Upload';
import { EditableField } from '../../components/EditableField/EditableField';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';

const fieldName = 'isAffiliatedExchangeOrFINRA';

interface Props extends SpaceProps {
  isReview?: boolean;
  draftAccount: DraftAccountDTO;
}

export const AffiliatedExchange: React.FC<Props> = ({ isReview, draftAccount, ...rest }) => {
  const formBag = useFormContext();

  const [isEditing, setIsEditing] = useState(!isReview);

  const [isAffiliatedExchangeOrFINRA, isCustodianEmployee] = formBag.watch([
    'isAffiliatedExchangeOrFINRA',
    'isCustodianEmployee',
  ]);

  if (isCustodianEmployee) {
    return null;
  }

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        <Text fontWeight={500}>{get(draftAccount, fieldName) ? 'Yes' : 'No'}</Text>

        {draftAccount.isAffiliatedExchangeOrFINRA && (
          <>
            <Text fontWeight={500}>{draftAccount.brokerDealerfirmName}</Text>
            <Letter407Upload isReadonly isReview={isReview} />
          </>
        )}
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            value={yesNoOpts.find(({ value }) => value === field.value)}
            label={
              isReview
                ? undefined
                : 'Are you or a family member employed by a Brokerage Firm, Securities Exchange, or FINRA?'
            }
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value);
              }
            }}
            options={yesNoOpts}
            aria-label="Are you or a family member employed by a Brokerage Firm, Securities Exchange, or FINRA?"
          />
        )}
      />

      {isAffiliatedExchangeOrFINRA && (
        <Box mt="8">
          <BrokerFirmName isReview={isReview} fieldName="brokerDealerfirmName" mb="4" />
          <Letter407Upload isReview={isReview} />
        </Box>
      )}
    </Box>
  );
};
